__turbopack_context__.v({
  "fieldWrapper": "CardInputFields-module-scss-module__VtLMrq__fieldWrapper",
  "fieldWrapperFocused": "CardInputFields-module-scss-module__VtLMrq__fieldWrapperFocused",
  "select": "CardInputFields-module-scss-module__VtLMrq__select",
  "wideField": "CardInputFields-module-scss-module__VtLMrq__wideField",
});
